import React from 'react';
import Text from './fields/text';
import Textarea from './fields/textarea';
import Select from './fields/select';
import Checkbox from './fields/checkbox';
import Checkboxes from './fields/checkboxes';
import Email from './fields/email';
import Password from './fields/password';
import Number from './fields/number';
import Button from './fields/button';
import AdvancedMultiselect from './fields/advanced-multiselect';
import Combobox from './fields/combobox';
import Comboboxes from './fields/comboboxes';
import Phone from './fields/phone';
import Radios from './fields/radios';

const FieldSwitch = (props) => {
  const { field } = props;
  switch (field.type) {
    case 'text':
      return <Text {...props} />
    case 'phone':
      return <Phone {...props} />
    case 'textarea':
      return <Textarea {...props} />
    case 'email':
      return <Email {...props} />
    case 'password':
      return <Password {...props} />
    case 'number':
      return <Number {...props} />
    case 'select':
      return <Select {...props} />
    case 'radios':
      return <Radios {...props} />
    case 'checkbox':
      return <Checkbox {...props} />
    case 'checkboxes':
      return <Checkboxes {...props} />
    case 'button':
      return <Button {...props} />
    case 'advanced-multiselect':
      return <AdvancedMultiselect {...props} />
    case 'combobox':
      return <Combobox {...props} />
    case 'comboboxes':
      return <Comboboxes {...props} />
    case 'custom':
      return field.render();
    default:
      return null;
  }
}

class Field extends React.Component {

  render() {
    const { field, error } = this.props;
    if (!field || !field.type) {
      return null;
    }
    const fieldProps = { ...this.props };
    if (error) {
      fieldProps.border = "red";
    }

    const skipLabel = field.type === 'checkbox' || !field.label;
    const helptextMarginTop = field.type === 'select' ? '-mt-2' : 'mt-1';

    return (
      <div className="mb-5">
        {!skipLabel && <label htmlFor={fieldProps.name} className="block text-gray-700 leading-5 font-medium text-sm mb-1">{field.label}</label>}
        <FieldSwitch {...fieldProps} />
        {error && <p className={`text-sm text-red-500 ${helptextMarginTop} mb-1 fielderror`}>{error}</p>}
        {field.helptext && <p className={`text-sm text-gray-500 ${helptextMarginTop} mb-1`}>{field.helptext}</p>}
      </div>
    );
  }
};

export default Field;